import { useCallback } from 'react';
import { ExternalToast, toast } from 'sonner';

import { ToastNotification, ToastNotificationProps } from '../../components/toast-notification';

export const useToaster = () => {
  const showToastNotification = useCallback((data: ShowToastNotificationProps) => {
    const { toastOptions, ...toastNotification } = data;

    return toast.custom((id) => <ToastNotification id={id} {...toastNotification} />, {
      className: 'toaster',
      unstyled: true,
      ...toastOptions,
    });
  }, []);

  return { showToastNotification };
};

type ShowToastNotificationProps = Omit<ToastNotificationProps, 'id'> & {
  toastOptions?: ExternalToast;
};
